export default __webpack_public_path__ + "static/media/263.565d578c.jpg";